export const GET_USER = 'GET_USER';
export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_ROLES = 'GET_ROLES';
export const GET_USERS = 'GET_USERS';
export const GET_USER_ME = 'GET_USER_ME';
export const GET_TEMPLATE_EMAILS = 'GET_TEMPLATE_EMAILS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CASES_STATUS = 'GET_CASES_STATUS';
export const GET_CASES = 'GET_CASES';
export const GET_CASE_APPLICATIONS = 'GET_CASE_APPLICATIONS';
export const GET_CASE_ID = 'GET_CASE_ID';
export const GET_CASE_COUNT = 'GET_CASE_COUNT';
export const GET_STATES = 'GET_STATES';
export const GET_CITIES = 'GET_CITIES';
export const GET_ALL_CITIES = 'GET_ALL_CITIES';
export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_CASES_STATES = 'GET_CASES_STATE';
export const GET_CASES_FILES = 'GET_CASES_FILES';
export const GET_STEPS = 'GET_STEPS';
export const GET_CASES_CLIENTS = 'GET_CASES_CLIENTS';
export const GET_CASES_STATUSES = 'GET_CASES_STATUSES';
export const GET_PINNED_CASES = 'GET_PINNED_CASES';
export const GET_ACTION_REQUIRED = 'GET_ACTION_REQUIRED';
export const GET_ALL_ACTION_REQUIRED = 'GET_ALL_ACTION_REQUIRED';
export const GET_SUMMARY = 'GET_SUMMARY';
export const GET_DASHBOARD_METRICS = 'GET_DASHBOARD_METRICS';
export const GET_DASHBOARD_SEARCH_RESULTS = 'GET_DASHBOARD_SEARCH_RESULTS';
export const GET_QUESTIONS_SUBJECTS = 'GET_QUESTIONS_SUBJECTS';
export const GET_INBOX_LIST = 'GET_INBOX_LIST';
export const GET_LAWYER_INBOX_LIST = 'GET_LAWYER_INBOX_LIST';
export const GET_CONVERSATIONS = 'GET_CONVERSATIONS';
export const GET_CONVERSATION_INFO = 'GET_CONVERSATION_INFO';
export const GET_INBOX_CASES = 'GET_INBOX_CASES';
export const GET_RECOVERY_SUMMARY = 'GET_RECOVERY_SUMMARY';
export const GET_RESOLVED_CASES = 'GET_RESOLVED_CASES';
export const GET_RECOVERED_CASES = 'GET_RECOVERED_CASES';
export const GET_COUNT_UNREAD_CONVERSATIONS = 'GET_COUNT_UNREAD_CONVERSATIONS';
export const GET_PENDING_NOTIFICATIONS = 'GET_PENDING_NOTIFICATIONS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_COMPLAINT_DOCUMENTS = 'GET_COMPLAINT_DOCUMENTS';
export const GET_DEMAND_LETTER = 'GET_DEMAND_LETTER';
export const GET_PAYPAL_ACCOUNT = 'GET_PAYPAL_ACCOUNT';
export const GET_VENMO_ACCOUNT = 'GET_VENMO_ACCOUNT';
export const GET_RETAINER_INFO = 'GET_RETAINER_INFO';
export const GET_QUESTIONS_FOLLOWUP = 'GET_QUESTIONS_FOLLOWUP';
export const GET_OPT_ACCEPTED = 'GET_OPT_ACCEPTED';
export const GET_REVIEW_SIGN_DETAILS = 'GET_REVIEW_SIGN_DETAILS';
export const GET_RETAINER_DATA = 'GET_RETAINER_DATA';

//Lawyer
export const GET_LAWYER_CASES = 'GET_LAWYER_CASES';
export const GET_LAWYER_CLIENTS = 'GET_LAWYER_CLIENTS';
export const GET_CASES_BY_CLIENT = 'GET_CASES_BY_CLIENT';
export const GET_CLIENT_ACCOUNT_DETAILS = 'GET_CLIENT_ACCOUNT_DETAILS';
export const GET_CLIENT_DIRECTORY = 'GET_CLIENT_DIRECTORY';
export const GET_CLIENT_DIRECTORY_ACTION_FILTER =
	'GET_CLIENT_DIRECTORY_ACTION_FILTER';
export const GET_CLIENT_DIRECTORY_MESSAGE_FILTER =
	'GET_CLIENT_DIRECTORY_MESSAGE_FILTER';
export const GET_CLIENT_DIRECTORY_CLIENT_FILTER =
	'GET_CLIENT_DIRECTORY_CLIENT__FILTER';
export const GET_CLIENT_DIRECTORY_CASES_FILTER =
	'GET_CLIENT_DIRECTORY_CASES__FILTER';
export const GET_CLIENT_DIRECTORY_SEGMENTATION_FILTER =
	'GET_CLIENT_DIRECTORY_SEGMENTATION__FILTER';
export const GET_FLAG_REASONS = 'GET_FLAG_REASONS';
export const GET_CLIENT_PROFILE_DASHBOARD = 'GET_CLIENT_PROFILE_DASHBOARD';
export const GET_CLIENT_PROFILE_CASES = 'GET_CLIENT_PROFILE_CASES';
export const GET_CLIENT_PROFILE_CASE_BY_ID = 'GET_CLIENT_PROFILE_CASE_BY_ID';
export const GET_CLIENT_PROFILE_ACTIONS_REQUIRED =
	'GET_CLIENT_PROFILE_ACTIONS_REQUIRED';
export const GET_CLIENT_PROFILE_FILES = 'GET_CLIENT_PROFILE_FILES';
export const GET_BRANDS = 'GET_BRANDS';
export const GET_BRANDS_USED_BY_CLIENT = 'GET_BRANDS_USED_BY_CLIENT';
export const GET_CLEANUP_WIZARD = 'GET_CLEANUP_WIZARD';
export const GET_CLEANUP_WIZARD_STATUS_FILTER =
	'GET_CLEANUP_WIZARD_STATUS_FILTER';
export const GET_CLEANUP_WIZARD_REASON_FILTER =
	'GET_CLEANUP_WIZARD_REASON_FILTER';
export const GET_CLEANUP_WIZARD_METRICS = 'GET_CLEANUP_WIZARD_METRICS';
export const GET_LAWYERS = 'GET_LAWYERS';
export const GET_CASE_TYPES = 'GET_CASE_TYPES';
export const GET_CASE_ENTITIES = 'GET_CASE_ENTITIES';
export const GET_LAWYER_CASES_LIST = 'GET_LAWYER_CASES_LIST';
export const GET_LAWYER_CASE_PHASES = 'GET_LAWYER_CASE_PHASES';
export const GET_LAWYER_CASE_STATUSES = 'GET_LAWYER_CASE_STATUSES';
export const GET_LAWYER_CASE_DETAILS = 'GET_LAWYER_CASE_DETAILS';
export const GET_LAWYER_CASE_METRICS = 'GET_LAWYER_CASE_METRICS';
export const GET_LAWYER_ACTION_REQUIRED = 'GET_LAWYER_ACTION_REQUIRED';
export const GET_CASES_CLIENTS_LAWYER_DIRECTORY =
	'GET_CASES_CLIENTS_LAWYER_DIRECTORY';
export const GET_CLIENTS_LAWYER_DIRECTORY = 'GET_CLIENTS_LAWYER_DIRECTORY';
export const GET_LAWYER_DIRECTORY_ACTION_FILTER =
	'GET_LAWYER_DIRECTORY_ACTION_FILTER';
export const GET_LAWYER_DIRECTORY_MESSAGE_FILTER =
	'GET_LAWYER_DIRECTORY_MESSAGE_FILTER';
export const GET_CLIENT_STEPPER_STATUSES = 'GET_CLIENT_STEPPER_STATUSES ';
export const GET_LAWYER_DIRECTORY_SEGMENT_FILTER =
	'GET_LAWYER_DIRECTORY_SEGMENT_FILTER';
export const GET_LAWYER_DIRECTORY_CASE_CLIENT_DETAIL =
	'GET_LAWYER_DIRECTORY_CASE_CLIENT_DETAIL';
export const GET_LAWYER_NOTES = 'GET_LAWYER_NOTES';
export const GET_LANDING_PAGE_CASE_DETAILS = 'GET_LANDING_PAGE_CASE_DETAILS';
export const GET_LANDING_PAGE_CASE_CLAIM_FORM =
	'GET_LANDING_PAGE_CASE_CLAIM_FORM';
export const GET_LANDING_PAGE_CASE_QUESTION_TYPE =
	'GET_LANDING_PAGE_CASE_QUESTION_TYPE';
export const GET_LAWYER_SIGN = 'GET_LAWYER_SIGN';
export const GET_CASE_STEPS_STATUS = 'GET_CASE_STEPS_STATUS';
export const GET_DOCUMENT_REQUIRED = 'GET_DOCUMENT_REQUIRED';
export const GET_LAWYER_RETAINER_INFO = 'GET_LAWYER_RETAINER_INFO';
export const GET_CLAIM_FORM = 'GET_CLAIM_FORM';
export const GET_FOLLOW_UP = 'GET_FOLLOW_UP';
export const GET_FOLLOW_UP_ANSWERS = 'GET_FOLLOW_UP_ANSWERS';
export const GET_CASE_UPDATES = 'GET_CASE_UPDATES';
export const GET_CASE_DOCUMENTS = 'GET_CASE_DOCUMENTS';
export const GET_CASE_CLIENTS_DOCUMENTS = 'GET_CASE_CLIENTS_DOCUMENTS';
export const GET_ELIGIBLE_STATES = 'GET_ELIGIBLE_STATES';
export const GET_OPT_SIGNATURES = 'GET_OPT_SIGNATURES';
export const GET_SAVED_OPT_CONFIG = 'GET_SAVED_OPT_CONFIG';
export const GET_SETTLEMENT_DETAILS = 'GET_SETTLEMENT_DETAILS';
export const GET_USERS_TO_PAY = 'GET_USERS_TO_PAY';
export const GET_ALL_OPT_SIGNATURES = 'GET_ALL_OPT_SIGNATURES';
export const GET_SETTLEMENT_USERS_SIGNS = 'GET_SETTLEMENT_USERS_SIGNS';
export const GET_CLIENT_CANCEL_STATUS = 'GET_CLIENT_CANCEL_STATUS';
export const GET_CLIENT_APPROVE_STATUS = 'GET_CLIENT_APPROVE_STATUS';
export const GET_DOCUMENT_SETTLEMENT = 'GET_DOCUMENT_SETTLEMENT';
export const GET_TEAM_MEMBERS = 'GET_TEAM_MEMBERS';
export const GET_LAWYER_ROLES = 'GET_LAWYER_ROLES';
export const GET_LAWYER_DETAIL = 'GET_LAWYER_DETAIL';
export const GET_LAWYER_DETAIL_CASES_LIST = 'GET_LAWYER_DETAIL_CASES_LIST';
export const ERROR_HANDLER = 'ERROR_HANDLER';
export const CLIENTS_DOCUMENTS = 'CLIENTS_DOCUMENTS';
export const GET_DOCUMENTS_CASE = 'GET_DOCUMENTS_CASE';
export const GET_VERSION_RECORDS = 'GET_VERSION_RECORDS';
export const GET_OPT_HISTORY = 'GET_OPT_HISTORY';
export const GET_DOCUMENT_RECORDS = 'GET_DOCUMENT_RECORDS';
export const GET_RETAINER_PACKAGE = 'GET_RETAINER_PACKAGE';
export const GET_SETTLEMENT_STATES = 'GET_SETTLEMENT_STATES';
export const GET_SETTLEMENT_SUMMARY = 'GET_SETTLEMENT_SUMMARY';
export const GET_PAYMENT_SUMMARY = 'GET_PAYMENT_SUMMARY';
export const GET_COMPLAINT_USER_COUNTS = 'GET_COMPLAINT_USER_COUNTS';
export const GET_AI_DOCUMENT_EVALUATION = 'GET_AI_DOCUMENT_EVALUATION';
export const GET_AI_SUMMARY = 'GET_AI_SUMMARY';
export const GET_REQUESTED_DOCUMENTS_CRITERIA =
	'GET_REQUESTED_DOCUMENTS_CRITERIA';
export const GET_FOLLOW_UP_QUESTIONS = 'GET_FOLLOW_UP_QUESTIONS';

// --------- Analytics ----------------//
export const GET_METRICS_OVERVIEW = 'GET_METRICS_OVERVIEW';
export const GET_METRICS_LAWYERS_ACTIVE = 'GET_METRICS_LAWYERS_ACTIVE';
export const GET_CLIENT_METRICS = 'GET_CLIENT_METRICS';
export const GET_CLIENT_METRICS_FILTERS = 'GET_CLIENT_METRICS_FILTERS';
export const GET_CLIENT_DATABASE_EXCEL = 'GET_CLIENT_DATABASE_EXCEL';
export const GET_APP_METRICS = 'GET_APP_METRICS';
export const GET_FEEDBACK_METRICS = 'GET_FEEDBACK_METRICS';
export const GET_VISITORS = 'GET_VISITORS';
export const GET_TOTAL_VISITORS = 'GET_TOTAL_VISITORS';
export const GET_TRAFFIC = 'GET_TRAFFIC';
export const GET_PAGE_VIEWS = 'GET_PAGE_VIEWS';
export const GET_TOTAL_PAGE_VIEWS = 'GET_TOTAL_PAGE_VIEWS';
export const GET_DEVICE_TYPE = 'GET_DEVICE_TYPE';
export const GET_AVERAGE_TIME = 'GET_AVERAGE_TIME';
export const GET_AVERAGE_TIME_ON_PAGE = 'GET_AVERAGE_TIME_ON_PAGE';
export const GET_AVERAGE_TIME_ON_PAGE_MONTH = 'GET_AVERAGE_TIME_ON_PAGE_MONTH';
export const GET_CALL_TO_ACTION_CLICKS = 'GET_CALL_TO_ACTION_CLICKS';
export const GET_DEVICE_REGISTERED = 'GET_DEVICE_REGISTERED';

// ----------------- Marketing -----------------//
export const GET_MARKETING = 'GET_MARKETING';
export const GET_CLIENT_TARGETING = 'GET_CLIENT_TARGETING';
export const GET_CLIENT_RETARGETING = 'GET_CLIENT_RETARGETING';
export const GET_CLIENT_RETARGETING_METRICS = 'GET_CLIENT_RETARGETING_METRICS';
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CAMPAIGN_BY_ID = 'GET_CAMPAIGN_BY_ID';
export const GET_CASES_WITH_CAMPAIGN = 'GET_CASES_WITH_CAMPAIGN';
export const GET_AVAILABLE_FILTER_BY_CASE_ID =
	'GET_AVAILABLE_FILTER_BY_CASE_ID';
export const GET_SCHEDULE_POSTS = 'GET_SCHEDULE_POSTS';
export const GET_PENDING_SCHEDULE_POSTS = 'GET_PENDING_SCHEDULE_POSTS';
export const GET_PENDING_PAID_SCHEDULE_POSTS =
	'GET_PENDING_PAID_SCHEDULE_POSTS';
export const GET_CAMPAIGNS_IMAGES = 'GET_CAMPAIGNS_IMAGES';
export const GET_CAMPAIGN_CASES = 'GET_CAMPAIGN_CASES';
export const GET_CAMPAIGN_METRICS = 'GET_CAMPAIGN_METRICS';
export const GET_CAMPAIGN_CHANNELS = 'GET_CAMPAIGN_CHANNELS';
export const GET_CLIENT_CALCULATION = 'GET_CLIENT_CALCULATION';
export const GET_RETARGETING_CASES = 'GET_RETARGETING_CASES';
export const GET_CLAIM_FORM_QUESTIONS = 'GET_CLAIM_FORM_QUESTIONS';
export const GET_PDF_EXTRACT_ALL = 'GET_PDF_EXTRACT_ALL';
